import { FC } from 'react'

// Components
import AutocompleteInput from 'components/organisms/AutocompleteInput/AutocompleteInput'
import CancelIcon from '@mui/icons-material/Cancel'
import { TextField } from '@mui/material'

// Logic
import { useCancelProcedureModalLogic } from './CancelProcedureModal.logic'

// Types
import { CancelProcedureModalProps } from './CancelProcedureModal.types'

// Components
import { CustomModal } from 'components/molecules/Modal/Modal'

// Styles
import styles from './CancelProcedureModal.module.scss'

// Form hook
import { Controller } from 'react-hook-form'

const CancelProcedureModal: FC<CancelProcedureModalProps> = (props) => {
  const { open, onClose } = props

  const {
    control,
    errors,
    isLoadingCancel,
    handleOnSubmit,
    cancellationOptions,
    isOtherSelected,
  } = useCancelProcedureModalLogic(props)

  return (
    <CustomModal
      isLoadingState={isLoadingCancel}
      header="Cancel Procedure"
      primaryButtonText="Cancel Procedure"
      open={open}
      secondaryButtonAction={onClose}
      handleOnSubmit={handleOnSubmit}
      primaryButtonDisabled={isLoadingCancel}
      icon={<CancelIcon />}
    >
      <form
        onSubmit={handleOnSubmit}
        className={styles.cancelProcedureModalForm}
      >
        <Controller
          name="reason"
          control={control}
          rules={{
            required: 'Cancellation reason is required',
          }}
          render={({ field: { onChange, value, ...field } }) => (
            <AutocompleteInput
              {...field}
              disabled={isLoadingCancel}
              required={false}
              variant="outlined"
              handleChangeFormData={onChange}
              placeholder="Select cancellation reason"
              label="Cancellation Reason*"
              options={cancellationOptions}
              error={!!errors.reason}
              helperText={errors.reason?.message}
              shrink={true}
              value={value}
              className={styles.autocompleteInput}
            />
          )}
        />

        {isOtherSelected && (
          <Controller
            name="customReason"
            control={control}
            rules={{
              required: isOtherSelected ? 'Please specify the reason' : false,
            }}
            render={({ field: { onChange, value, ...field } }) => (
              <TextField
                {...field}
                disabled={isLoadingCancel}
                variant="outlined"
                placeholder="Please specify the reason"
                label="Custom Reason*"
                value={value}
                onChange={onChange}
                error={!!errors.customReason}
                helperText={errors.customReason?.message}
                fullWidth
                multiline
                rows={3}
                className={styles.customReasonTextField}
              />
            )}
          />
        )}
      </form>
    </CustomModal>
  )
}

export default CancelProcedureModal
